import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TestHooks } from './leap-create-matter.hooks';

@Component({
	selector: 'app-leap-create-matter',
	templateUrl: './leap-create-matter.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class LeapCreateMatterComponent {
	testHooks = TestHooks;
}
